import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/calculer.png'
import _imports_1 from '../assets/retour.png'


const _withScopeId = n => (_pushScopeId("data-v-37c18279"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-8 h-8",
  alt: ""
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-16 h-16 bg-blue-500 rounded-full",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Questions = _resolveComponent("Questions")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Questions, {
      id: "card",
      Presentation: "La puissance mécanique, c’est la quantité d’énergie utilisée ou produite en un certain temps. Par exemple, si tu pousses une balançoire très fort, tu donnes beaucoup d’énergie rapidement, donc tu as une grande puissance. Mais si tu pousses doucement, tu as moins de puissance, car tu donnes l’énergie plus lentement. C’est comme mesurer à quelle vitesse on utilise ou produit de l’énergie !",
      titre: "Puissannce mécanique",
      cacherCard: _ctx.cacherCard,
      fichier: "puissance_mecanique"
    }, null, 8, ["cacherCard"]),
    _createElementVNode("main", {
      class: _normalizeClass({ 'blur-sm': _ctx.flou == true })
    }, [
      _createElementVNode("div", {
        class: "absolute bottom-5 right-24 bg-white py-3 px-4 bg-white rounded-full flex justify-center items-center cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.testfinal && _ctx.testfinal(...args)))
      }, " Fin de la simulation "),
      _createElementVNode("div", {
        class: "absolute top-2 left-2 bg-white w-16 h-16 rounded-full flex justify-center items-center cursor-pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.voirCalcul()))
      }, _hoisted_2),
      _createVNode(_component_LoadingScreen, { isLoaded: _ctx.loaded }, null, 8, ["isLoaded"]),
      _hoisted_3,
      _createElementVNode("div", {
        class: "fixed z-40 right-2 bottom-5 w-16 h-16",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.actualiser && _ctx.actualiser(...args)))
      }, _hoisted_5)
    ], 2)
  ], 64))
}